export const NG_DOC_DYNAMIC_SELECTOR = 'ng-doc-selector';
